import CallOutsPanel from './CallOutsPanel';
import ComponentWrapper from '../../fragments/component-wrapper/ComponentWrapper';
import ComponentHeading from '../../fragments/heading/ComponentHeading';

export default function CallOuts({ block, index }) {
  if (!block) return null;

  const columns = Math.min(block.callOutItems.length, 4);
  const HeadingTag = index == 0 ? 'h1' : 'h2';

  return (
    <ComponentWrapper block={block} className="CallOuts">
      <div className="l-grid" style={{ '--icon-columns': columns }}>
        {/* {block.heading && (
          <ComponentHeading
            heading={block.heading}
            description={block.description}
            firstBlock={index === 0}
          />
        )} */}

        <div
          className={`l-grid__col ${columns < 4 ? 'l-grid__col--l-10-12 l-grid__col--l-push-1-12' : ''}`}
        >
          {block.heading && (
            <>
              <HeadingTag
                className={'CallOuts-heading'}
                style={{ maxWidth: '34ch' }}
                dangerouslySetInnerHTML={{ __html: block.heading }}
              />
              {/* {cta && <Cta cta={cta} />} */}
              <hr />
            </>
          )}

          {block.callOutItems && (
            <div className={'CallOuts-icons'}>
              {block.callOutItems.map((item, index) => {
                return <CallOutsPanel item={item} key={index} />;
              })}
            </div>
          )}
        </div>
      </div>
    </ComponentWrapper>
  );
}
